// App Settings
// -----------------------------------
export class Application {
    public name: string;
    public description: string;
    public year: number = new Date().getFullYear();
}

// Layout Settings
// -----------------------------------
export class Layout {
    theme: null;
    isFixed: boolean = true;
    isCollapsed: boolean = false;
    isBoxed: boolean = false;
    isRTL: boolean = false;
    horizontal: boolean = false;
    isFloat: boolean = false;
    asideHover: boolean = false;
    asideScrollbar: boolean = false;
    isCollapsedText: boolean = false;
    useFullLayout: boolean = false;
    hiddenFooter: boolean = false;
    offsidebarOpen: boolean = false;
    asideToggled: boolean = false;
    viewAnimation: 'ng-fadeInUp';
}

// Settings
// -----------------------------------
export class Settings {
    public app: Application;
}
